<div class="payment-page">
  <div class="payment-page__inner">
    <div class="payment-topbar">
      <button type="button" class="back-btn" (click)="backToCheckout()">
        <i class="fa-solid fa-arrow-left"></i>
        <span>Back to Your Details</span>
      </button>
    </div>

    <div class="payment-layout">
      <div class="payment-container">
        <header class="payment-header">
          <h2>Secure Payment</h2>
        </header>

        <section
          class="payment-body"
          [class.is-loading]="isInitialisingPayment"
          [attr.aria-busy]="isInitialisingPayment"
          >
          @if (isInitialisingPayment) {
            <div class="payment-loading">
              <span class="payment-loading__spinner" aria-hidden="true"></span>
              <div>
                <h3>Loading secure payment</h3>
                <p>{{ paymentInitMessage }}</p>
              </div>
            </div>
          }

          <div class="wallet-wrap" [class.is-hidden]="!walletAvailable">
            <div class="wallet-shell">
              <div id="payment-request-button" #prbHost></div>
            </div>
          </div>

          <div class="card-shell">
            <div class="card-shell__header">
              <label for="card-element" class="field-label">Card Details</label>
              <div class="brand-chip">Powered by Stripe</div>
            </div>

            <div
              class="card-frame"
              [ngClass]="{
                'is-complete': cardComplete,
                'is-invalid': !!cardError,
              }"
              >
              <div id="card-element" #cardHost class="card-element"></div>
            </div>
          </div>

          @if (cardError) {
            <p class="error" id="card-error">{{ cardError }}</p>
          }

          <p class="secure-note">
            Payments are encrypted and securely processed.
          </p>

          <button
            class="pay-button"
            [disabled]="
              !paymentReady ||
              !cardComplete ||
              isPaying ||
              isInitialisingPayment
            "
            (click)="pay()"
            aria-live="polite"
            [attr.aria-describedby]="cardError ? 'card-error' : null"
            >
            @if (!isPaying) {
              <span>Place Order</span>
            }
            @if (isPaying) {
              <span
                class="spinner"
                aria-label="Processing…"
              ></span>
            }
          </button>
        </section>
      </div>

      <aside class="payment-sidebar">
        <app-order-summary
          [title]="'Basket'"
          [cartItems]="summaryItems"
          [orderNotes]="orderNotes"
          [isEditingNotes]="false"
          [orderNotesDraft]="''"
          [serviceFee]="summaryServiceFee"
          [deliveryFee]="summaryDeliveryFee"
          [smallOrderFee]="summarySmallOrderFee"
          [total]="summaryTotal"
          [isDelivery]="orderType === 'delivery'"
          [editableNotes]="false"
        ></app-order-summary>
      </aside>
    </div>
  </div>
</div>
